// TIP-611 — the confirmation the order form switches to in place.
// ONE frame, five wordings. Everything drawn here is fixed except the sentence
// under the heading and the second button, both of which come from
// deriveConfirmation() in orderFormState.js. Adding a sixth variant is a change
// to that function and to nothing here.
import React from "react";
import "./counterpartyBriefs.css";
import CbButton from "./CbButton";
import { CONFIRMATION_COPY } from "./orderFormFixtures";
import { deriveConfirmation } from "./orderFormState";

const Meta = ({ label, value, mono }) => (
  <div className="cb-confirm-meta-item">
    <span className="cb-confirm-meta-label">{label}</span>
    <span className={`cb-confirm-meta-value${mono ? " cb-confirm-meta-value--mono" : ""}`}>
      {value}
    </span>
  </div>
);

const OrderConfirmation = ({ order, allowance, onClose, onOrderAnother, onBuy }) => {
  const variant = deriveConfirmation(allowance);
  const company = order.company || CONFIRMATION_COPY.fallbackCompany;

  return (
    <div className="cb-confirm" data-testid="cb-order-confirmation" data-variant={variant.variant}>
      <div className="cb-confirm-head">
        <span className="cb-confirm-tick" aria-hidden="true">
          &#10003;
        </span>
        <div>
          <span className="cb-confirm-eyebrow">{CONFIRMATION_COPY.eyebrow}</span>
          <h2 className="cb-confirm-title">{CONFIRMATION_COPY.heading(company)}</h2>
          {/* The sentence and its fixed tail are one paragraph, as designed. */}
          <p className="cb-confirm-sentence" data-testid="cb-confirm-sentence">
            {variant.sentence} {CONFIRMATION_COPY.sentenceTail}
          </p>
        </div>
      </div>

      <div className="cb-confirm-meta">
        <Meta label={CONFIRMATION_COPY.referenceLabel} value={order.reference} mono />
        <Meta label={CONFIRMATION_COPY.placedLabel} value={order.placed} />
        <Meta label={CONFIRMATION_COPY.readyLabel} value={CONFIRMATION_COPY.ready} />
      </div>

      <div className="cb-confirm-steps">
        <span className="cb-confirm-steps-heading">{CONFIRMATION_COPY.stepsHeading}</span>
        {CONFIRMATION_COPY.steps.map((step, i) => (
          <div className="cb-confirm-step" key={step.label}>
            <span className={`cb-confirm-step-mark${i === 0 ? " is-done" : ""}`} aria-hidden="true">
              {i === 0 ? "✓" : i + 1}
            </span>
            <span className="cb-confirm-step-text">
              <strong>{step.label}</strong> {step.detail}
            </span>
          </div>
        ))}
      </div>

      <div className="cb-confirm-actions">
        <CbButton onClick={onClose}>{CONFIRMATION_COPY.primary}</CbButton>
        <CbButton
          variant="secondary"
          data-testid="cb-confirm-secondary"
          onClick={variant.secondaryAction === "buy" ? onBuy : onOrderAnother}
        >
          {variant.secondary}
        </CbButton>
      </div>
    </div>
  );
};

export default OrderConfirmation;
